import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    ToggleButtonGroup,
    ToggleButton,
} from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { VChainerFooter } from '../../../app/components/VChainerFooter';
import { useAppSelector } from '../../../app/hooks';
import { Locale, selectSettings } from '../../settings/settingsSlice';
import { LanguageToggle } from '../../../app/components/LanguageToggle';

const texts = {
    title: {
        pl: 'Dziękujemy za skorzystanie z systemu V-Chainer',
        en: 'Thank you for using the V-Chainer system',
        de: 'Vielen Dank, dass Sie V-Chainer nutzen',
    },
    list: {
        commentSent: {
            pl: 'Oceny i komentarze zostały przesłane do autora dokumentu.',
            en: 'Ratings and comments have been sent to the document author.',
            de: 'Bewertungen und Kommentare wurden an den Verfasser des Dokuments gesendet.',
        },
        pdfSent: {
            pl: 'Skomentowany dokument PDF został wysłany na Twój adres e-mail.',
            en: 'The commented PDF document has been sent to your email address.',
            de: 'Das kommentierte PDF-Dokument wurde an Ihre E-Mail-Adresse gesendet.',
        },
        pdfNote: {
            pl: 'Jeśli nie widzisz wiadomości w skrzynce odbiorczej, sprawdź folder SPAM lub skontaktuj się z naszym zespołem wsparcia.',
            en: 'If you don’t see the message in your inbox, check the SPAM folder or contact our support team.',
            de: 'Falls Sie die Nachricht nicht im Posteingang finden, prüfen Sie den Spam-Ordner oder kontaktieren Sie unser Support-Team.',
        },
        registrationSelected: {
            pl: 'Wybrano opcję z rejestracją w systemie V-Chainer.',
            en: 'You selected the option to register in the V-Chainer system.',
            de: 'Sie haben sich für eine Registrierung bei V-Chainer entschieden.',
        },
        registrationNote: {
            pl: 'Dziękujemy za dołączenie! Twoje konto zostanie aktywowane zgodnie z ustawieniami dostępu. Do zobaczenia wkrótce w systemie VChainer!',
            en: 'Thank you for joining! Your account will be activated according to access settings. See you soon in the V-Chainer system!',
            de: 'Vielen Dank für Ihre Anmeldung! Ihr Konto wird gemäß den Zugriffseinstellungen aktiviert. Bis bald bei V-Chainer!',
        },
    },
};


const RegisteredCommentSentPanel: React.FC = () => {
    const { locale } = useAppSelector(selectSettings);

    const [language, setLanguage] = useState<Locale>(locale);
    const lang = language === 'en-US' ? 'en' : language;


    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f4f6f8"
            p={2}
        >
            <Paper elevation={4} sx={{ p: 5, maxWidth: 700, borderRadius: 3, position: 'relative', textAlign: 'center' }}>
                <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
                    <LanguageToggle onChange={setLanguage} />

                </Box>
                <MarkEmailReadIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />

                <Typography variant="h5" gutterBottom>
                    {texts.title[lang]}
                </Typography>

                <List sx={{ textAlign: 'left', mb: 3 }}>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleIcon color="success" />
                        </ListItemIcon>
                        <ListItemText primary={texts.list.commentSent[lang]} />
                    </ListItem>

                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleIcon color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary={texts.list.pdfSent[lang]}
                            secondary={texts.list.pdfNote[lang]}
                        />
                    </ListItem>

                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleIcon color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary={texts.list.registrationSelected[lang]}
                            secondary={texts.list.registrationNote[lang]}
                        />
                    </ListItem>
                </List>
                <Divider />
                <VChainerFooter />
            </Paper>
        </Box>
    );
};

export default RegisteredCommentSentPanel;
